import { useState } from 'react'
import { useAuthStore } from '@/stores/auth.store'

export function EmailVerificationBanner() {
  const { user, resendVerification } = useAuthStore()
  const [isResending, setIsResending] = useState(false)
  const [message, setMessage] = useState<string | null>(null)
  const [devUrl, setDevUrl] = useState<string | null>(null)

  // Don't show if user is verified or not a parent
  if (!user || user.emailVerified || user.role !== 'parent') {
    return null
  }

  const handleResend = async () => {
    setIsResending(true)
    setMessage(null)
    setDevUrl(null)

    try {
      const result = await resendVerification()
      setMessage('Verification email sent! Check your inbox.')
      if (result.verificationUrl) {
        setDevUrl(result.verificationUrl)
      }
    } catch {
      setMessage('Failed to send verification email. Please try again.')
    } finally {
      setIsResending(false)
    }
  }

  return (
    <div className="mb-4 rounded-lg border border-amber-200 bg-amber-50 p-4">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0">
          <svg className="h-5 w-5 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        <div className="flex-1">
          <h3 className="font-medium text-amber-800">Verify your email</h3>
          <p className="mt-1 text-sm text-amber-700">
            Please verify your email address ({user.email}) to view your children's updates.
          </p>

          {message && (
            <p className="mt-2 text-sm text-amber-700">{message}</p>
          )}

          {devUrl && (
            <p className="mt-1 text-xs text-amber-600 break-all">
              Dev URL: <a href={devUrl} className="underline">{devUrl}</a>
            </p>
          )}

          <button
            onClick={handleResend}
            disabled={isResending}
            className="mt-2 text-sm font-medium text-amber-800 hover:text-amber-900 disabled:opacity-50"
          >
            {isResending ? 'Sending...' : 'Resend verification email'}
          </button>
        </div>
      </div>
    </div>
  )
}
